import { Components, Theme } from '@mui/material'

export const MuiSwitch: Components<Omit<Theme, 'components'>>['MuiSwitch'] = {
  defaultProps: {
    size: 'medium',
  },
  styleOverrides: {
    root: ({ theme }) => {
      const height = 24
      return {
        width: 44,
        height,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 0,
          margin: 2,
          transitionDuration: '300ms',
          '&.Mui-checked': {
            transform: 'translateX(20px)',
            color: theme.palette.common.white,
            '& + .MuiSwitch-track': {
              backgroundColor: theme.palette.secondary[500] || theme.palette.secondary.main,
              opacity: 1,
              border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.5,
            },
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: `6px solid ${theme.palette.common.white}`,
          },
          '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[100],
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'dark' ? 0.3 : 0.7,
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 20,
          height: 20,
        },
        '& .MuiSwitch-track': {
          borderRadius: height / 2,
          backgroundColor: theme.palette.mode === 'dark' ? '#39393D' : '#E9E9EA',
          opacity: 1,
          transition: theme.transitions.create(['background-color'], {
            duration: 500,
          }),
        },
      }
    },
  },
  variants: [
    {
      props: { size: 'small' },
      style: ({ theme }) => {
        const height = 16
        return {
          width: 28,
          height,
          margin: theme.spacing(2),
          '& .MuiSwitch-thumb': {
            width: 12,
            height: 12,
          },
          '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
              transform: 'translateX(12px)',
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
              border: `4px solid ${theme.palette.common.white}`,
            },
          },
          '& .MuiSwitch-track': {
            borderRadius: height / 2,
          },
        }
      },
    },
  ],
}
